var _circle, _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReact = function SvgReact(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    className: "st0",
    cx: 300,
    cy: 300,
    r: 50
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st0",
    d: "M300 415c-71 0-133-9-179-24-30-11-55-24-73-40-19-16-29-34-29-51 0-34 36-66 97-87 50-18 115-27 183-27 67 0 132 9 181 26 29 10 54 23 71 38 19 15 29 33 29 50 0 34-40 69-106 91-46 15-108 24-174 24zm0-205c-65 0-129 9-176 25-56 20-81 47-81 65s27 47 86 68c44 15 103 23 171 23 63 0 122-8 167-23 61-21 89-50 89-68 0-10-7-21-20-32-15-13-37-24-63-33-48-16-109-25-173-25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st0",
    d: "M186 550c-11 0-20-2-27-7-29-16-39-64-27-128 10-52 34-113 68-172 34-58 74-109 114-144 23-20 46-35 68-42 23-9 43-9 57-1 30 18 40 70 26 138-10 48-33 106-66 163-36 61-74 110-110 143-24 20-49 36-71 43-12 5-23 7-32 7zm25-301l10 6c-32 56-56 116-65 165-11 58-1 93 15 102 3 3 8 4 15 4 19 0 51-13 87-44 35-31 71-78 105-137 32-55 54-110 64-156 13-63 1-102-15-112-8-4-21-4-37 2-19 7-40 20-61 39-37 32-76 81-108 137l-10-6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st0",
    d: "M413 550c-27 0-61-16-97-47-41-35-81-86-116-145-33-58-57-119-67-170-6-31-7-58-4-81 5-24 15-41 29-50 30-17 81 1 132 47 37 32 75 82 108 139 36 61 60 118 69 166 6 31 7 60 3 83-5 25-15 43-30 52-8 4-17 6-27 6zM221 346c33 56 73 106 110 139 45 38 81 47 97 38 16-10 28-48 15-109-9-45-31-100-65-159-32-55-69-103-104-133-48-44-87-53-104-44-8 5-14 17-17 33-3 20-2 45 3 72 10 49 33 107 65 163z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/react.b5b96b75.svg";
export { ForwardRef as ReactComponent };